import { cva } from 'class-variance-authority';

export const icon = cva(['text-brand-pure']);

export const button = cva([
  'flex',
  'z-[200]',
  'gap-2',
  'items-center',
  'justify-center',
  'shadow-default',
  'hover:transition-all',
  'cursor-pointer',
  'disabled:opacity-50 disabled:cursor-not-allowed',
  'rounded-md',
  'w-full',
  'min-w-max',
  'text-brand-800',
  'bg-white',
  'hover:bg-brand-100',
  'border',
  'border-neutral-300',
  'shadow',
  'p-3',
  'text-sm',
]);
